export default __webpack_public_path__ + "static/media/feedionameCropped.f1d7d46d.png";